import cmp from '../../lib/cmp';
import on from '../../lib/dom/on';
import { removeClass } from '../../lib/dom/className';
import template from './sm-landing-appstore-app-1-section-text.template.js';
import './sm-landing-appstore-app-1-section-text.less';



export default cmp(null, template, (element) => {
  const offClick = on(element, 'click', () => {
    removeClass(element, 'sm-landing-appstore-app-1-section-text--show-more');
    offClick();
  });

  return () => {
    offClick();
  };
});



// WEBPACK FOOTER //
// ./src/landing-appstore-app-1/sm-landing-appstore-app-1-section-text/sm-landing-appstore-app-1-section-text.js